import { Check } from 'lucide-react';
import { cn } from '@/lib/utils';

interface StepperStep {
  key: string;
  label: string;
}

interface ShipmentStatusStepperProps {
  currentStep: number;
  steps?: StepperStep[];
  className?: string;
}

const defaultSteps: StepperStep[] = [
  { key: 'pending',          label: 'قيد الانتظار' },
  { key: 'out_for_pickup',   label: 'خرج للاستلام' },
  { key: 'collected',        label: 'تم الاستلام' },
  { key: 'in_transit',       label: 'في الطريق' },
  { key: 'out_for_delivery', label: 'خرج للتوصيل' },
  { key: 'delivered',        label: 'تم التسليم' },
];

export function ShipmentStatusStepper({ 
  currentStep, 
  steps = defaultSteps,
  className 
}: ShipmentStatusStepperProps) {
  return (
    <div className={cn("w-full py-4", className)}>
      <div className="flex items-center justify-between">
        {steps.map((step, index) => {
          const isCompleted = index < currentStep;
          const isCurrent = index === currentStep;
          
          return (
            <div key={step.key} className="flex items-center flex-1 last:flex-none">
              {/* Step circle */}
              <div className="flex flex-col items-center">
                <div
                  className={cn(
                    "w-8 h-8 rounded-full flex items-center justify-center text-sm font-medium transition-colors",
                    isCompleted && "bg-green-500 text-white",
                    isCurrent && "bg-primary text-primary-foreground",
                    !isCompleted && !isCurrent && "bg-muted text-muted-foreground"
                  )}
                >
                  {isCompleted ? (
                    <Check className="h-4 w-4" />
                  ) : (
                    <span>{index + 1}</span>
                  )}
                </div>
                <span
                  className={cn(
                    "mt-2 text-xs text-center whitespace-nowrap",
                    isCompleted && "text-green-600 font-medium",
                    isCurrent && "text-primary font-medium",
                    !isCompleted && !isCurrent && "text-muted-foreground"
                  )}
                >
                  {step.label}
                </span>
              </div>
              
              {/* Connector line */}
              {index < steps.length - 1 && (
                <div
                  className={cn(
                    "flex-1 h-0.5 mx-2",
                    index < currentStep ? "bg-green-500" : "bg-muted"
                  )}
                />
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
